'use strict';

const swiperGeneralNew = new Swiper('.swiper-container.gallery_swiper', {
      slidesPerView: 3,
      spaceBetween: 30,
      slidesPerGroup: 1,
      loop: true,
      loopFillGroupWithBlank: true,
      autoplay: {
        delay: 3500,
      },
      navigation: {
        nextEl: '.swiperG-button-next',
        prevEl: '.swiperG-button-prev',
      },
      breakpoints:{

          640: {

            slidesPerView: 1,
            spaceBetween: 10

          },
          1000: {

            slidesPerView: 2,
            spaceBetween: 20

          }

      }
    });
